export const ADDRESS_INPUT_LIMIT = 4;
